import React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  SearchStats,
  SearchkitWrapper,
} from '@uncinc/react-searchkit';

import { SEARCHKIT_HOST_URL, APP_OPTIONS } from '../../config/constants';
import { PageHeader, Breadcrumbs, SearchPagination, SearchBar, SearchResults, SearchSortBy } from '../../components';
import SearchFacets from './SearchFacets';

import {
  SEARCH_FACET_ATTRIBUTES,
  SEARCH_SORTING_OPTIONS,
  SEARCH_RESULT_ATTRIBUTES,
  SEARCH_SEARCH_ATTRIBUTES,
  SEARCH_REQUEST_OPTIONS,
} from './config';

import './style.scss';

const SEARCH_ITEMS_PER_PAGE = 6;

const Search = () => {
  const sortOptionDate = `${APP_OPTIONS.parameters.searchkitIndexAllContent}_created_desc`;
  const sortOptionScore = APP_OPTIONS.parameters.searchkitIndexAllContent;

  return (
    <div className="Search">
      <SearchkitWrapper
        connection={{ host: SEARCHKIT_HOST_URL }}
        indexName={APP_OPTIONS.parameters.searchkitIndexAllContent}
        hitsPerPage={SEARCH_ITEMS_PER_PAGE}
        initialUiState={{
          [APP_OPTIONS.parameters.searchkitIndexAllContent]: {
            sortBy: sortOptionDate,
          },
        }}
        routing
        searchSettings={{
          search_attributes: SEARCH_SEARCH_ATTRIBUTES,
          result_attributes: SEARCH_RESULT_ATTRIBUTES,
          facet_attributes: SEARCH_FACET_ATTRIBUTES,
          sorting: SEARCH_SORTING_OPTIONS,
        }}
        requestOptions={SEARCH_REQUEST_OPTIONS}
      >
        <PageHeader>
          <div className="PageHeader__content">
            <Breadcrumbs overrideTitle="Zoeken" overrideUrl="/" />
            <h1 className="PageHeader__title">Zoeken</h1>
            <div className="PageHeader__content__searchbar">
              <SearchBar
                defaultSorting={sortOptionDate}
                relevanceSorting={sortOptionScore}
              />
            </div>
          </div>
        </PageHeader>

        <Container>
          <div className="row SearchContent">
            <div className="col-12 col-lg-4">
              {/* Search facet rendering */}
              <SearchFacets />
            </div>
            <div className="col-12 col-lg-8">
              <div className="Searchkit__result_section">
                <div className="Searchkit__Header">
                  {/* Result count Heading */}
                  <SearchStats
                    translation={(numberOfHits) => `${numberOfHits} resultaten`}
                  />

                  {/* Sort Heading */}
                  <SearchSortBy />
                </div>

                {/* Results */}
                <SearchResults />

                {/* Pagination */}
                <SearchPagination />
              </div>
            </div>
          </div>
        </Container>
      </SearchkitWrapper>
    </div >
  );
};

export default Search;
